module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-main"
  }, [_c('h3', [_vm._v("请长按二维码")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("关注 “明源云” 公众号")]), _vm._v(" "), _c('img', {
    staticClass: "qrocde",
    attrs: {
      "src": _vm.img,
      "alt": "qr-code"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("一到三个工作日内")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("在 “明源云” 公众号")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("查看处理结果")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-547430d0"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/result.vue
// module id = 283
// module chunks = 1